import type { Community } from '@communities/community/domain';
import { CardGrid } from '@core/components/CardGrid';
import { Card, Text } from '@soteria/design-system-ve';

import { CommunityCard } from './CommunityCard';
import * as styles from './CommunityGrid.css';

export interface CommunityGridProps {
  /**
   * List of communities to display in the grid
   */
  communities: Community[];

  /**
   * Function called when a community card is clicked
   */
  onSelectCommunity: (community: Community) => void;

  /**
   * Whether to use auto-fit or auto-fill for grid columns
   * @default "auto-fit"
   */
  columnFit?: 'auto-fit' | 'auto-fill';

  /**
   * Gap between grid items
   * @default "medium"
   */
  gap?: 'small' | 'medium' | 'large';

  /**
   * Custom class name for the empty state message
   */
  emptyStateClassName?: string;

  /**
   * Whether to include gameTitle property on community cards
   * @default false
   */
  includeGameTitle?: boolean;
}

export function CommunityGrid({
  communities,
  onSelectCommunity,
  columnFit = 'auto-fit',
  gap = 'medium',
  emptyStateClassName,
  includeGameTitle = false,
}: CommunityGridProps) {
  if (communities.length === 0) {
    return (
      <Card elevation="low" padding="medium">
        <Text className={emptyStateClassName || styles.emptyState}>No communities found in this group.</Text>
      </Card>
    );
  }

  return (
    <CardGrid columns={columnFit} gap={gap}>
      {communities.map(community => (
        <CommunityCard
          key={community.id}
          community={
            includeGameTitle
              ? {
                  ...community,
                }
              : community
          }
          isSelected={false}
          onClick={() => onSelectCommunity(community)}
        />
      ))}
    </CardGrid>
  );
}
